// extracted by mini-css-extract-plugin
export default {"stats":"RestaurantBookingStats_stats__JdeG4","section":"RestaurantBookingStats_section__TfybG","small":"RestaurantBookingStats_small__siVHT"};